import {PlaceholderComponent} from '../shared/placeholder.component';
import {RoomFormComponent} from './room-form.component';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {dynamicStateConfigFn, Ng2DynamicStateDeclaration} from '@ngx-ivengi/locale';

export let CHILD_STATES: Ng2DynamicStateDeclaration[] = [
  {
    name: 'building.edit.floor.edit.room',
    abstract: true,
    component: PlaceholderComponent,
    future: true,
    data: {
      pageTitle: 'states.room.pageTitle',
      scopes: ['room:read']
    }
  },
  {
    name: 'building.edit.floor.edit.room.add',
    component: RoomFormComponent,
    future: true,
    data: {
      pageTitle: 'states.room.add.pageTitle',
      scopes: ['room:create']
    }
  },
  {
    name: 'building.edit.floor.edit.room.edit',
    component: RoomFormComponent,
    future: true,
    data: {
      pageTitle: 'states.room.edit.pageTitle',
      scopes: ['room:update']
    }
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: CHILD_STATES,
      config: dynamicStateConfigFn
    }),
    TranslateModule
  ],
  exports: [UIRouterModule]
})
export class RoomRoutingModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/room/room.routes.ts